/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Features_Upload_DescriptionInputs */

const en_homepage_features_upload_description = /** @type {(inputs: Homepage_Features_Upload_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We support PDFs, Word, MOBI, EPUB, and even taking photos of physical pages.`)
};

const es_homepage_features_upload_description = /** @type {(inputs: Homepage_Features_Upload_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soportamos PDFs, Word, MOBI, EPUB e incluso fotos de páginas físicas.`)
};

/**
* | output |
* | --- |
* | "We support PDFs, Word, MOBI, EPUB, and even taking photos of physical pages." |
*
* @param {Homepage_Features_Upload_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_features_upload_description = /** @type {((inputs?: Homepage_Features_Upload_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Features_Upload_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_features_upload_description(inputs)
	return en_homepage_features_upload_description(inputs)
});